<template>
  <div id="app">
    <v-container>
      <!-- <Header /> -->
      <v-row justify="center" align="center">
        <div style="max-width: 500px; margin-top: 10px;">
          <a href="/">
            <img src="/assets/img/logo-hp.png" style="max-width: 100%; width: 100%;" />
          </a>
        </div>
      </v-row>

      <v-col :cols="12" style="margin:0; padding:0;">
        <v-row justify="center" align="center">
          <v-col cols="12" sm="6" md="7" lg="6">
            <v-card class="mx-auto entercodebox" flat color="transparent">
              <v-card-text>
                <!-- <p class="display-1">Enter Event Code</p> -->

                <v-text-field
                  label="Enter Event Code"
                  outlined
                  v-model="code"
                  class="entercodeboxinput hp--btn"
                  @keydown.enter="submitEventCode"
                ></v-text-field>

                <v-btn
                  @click="submitEventCode"
                  depressed
                  large
                  color="primary"
                  block
                  class="hp--btn"
                >Submit</v-btn>
                <br />
                <v-btn
                  depressed
                  large
                  block
                  class="managebookingsbutton hp--btn"
                  @click="manageBooking"
                >Manage my booking</v-btn>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col :cols="12">
            <v-row justify="center" align="center" style="margin:0 50px;">
              <v-col :cols="2" style="text-align: center;">
                <img src="/assets/img/fgraphicHeart.png" style="max-height: 100px;" />
              </v-col>
              <v-col :cols="2" style="text-align: center;">
                <img src="/assets/img/fgraphicApple.png" style="max-height: 100px;" />
              </v-col>
              <v-col :cols="2" style="text-align: center;">
                <img src="/assets/img/fgraphicSteth.png" style="max-height: 100px;" />
              </v-col>
              <v-col :cols="2" style="text-align: center;">
                <img src="/assets/img/fgraphicSpine.png" style="max-height: 100px;" />
              </v-col>
              <v-col :cols="2" style="text-align: center;">
                <img src="/assets/img/fgraphicMind.png" style="max-height: 100px;" />
              </v-col>
              <v-col :cols="2" style="text-align: center;">
                <img src="/assets/img/fgraphicWalk.png" style="max-height: 100px;" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <Footer />
    </v-container>
  </div>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
export default {
  data() {
    return {
      code: "",
    };
  },
  components: {
    Header,
    Footer,
  },
  methods: {
    submitEventCode() {
      this.$router.push({
        name: "bookevent",
        params: { eventcode: this.code },
      });
    },
    manageBooking() {
      this.$router.push({ name: "managebooking" });
    },
  },
};
</script>